import React, { useState } from 'react';
import { updateUserPassword } from '../../services/authService';

interface RecoveryPasswordFormModalProps {
  onCompleted: () => void;
}

/** 비밀번호 재설정 링크로 진입한 뒤 새 비밀번호를 설정합니다. */
const RecoveryPasswordFormModal: React.FC<RecoveryPasswordFormModalProps> = ({ onCompleted }) => {
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const canSubmit = password.length >= 6 && password === password2;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!canSubmit) {
      setError('비밀번호는 6자 이상이며, 두 입력이 같아야 합니다.');
      return;
    }
    setBusy(true);
    try {
      await updateUserPassword(password);
      onCompleted();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : '비밀번호를 변경하지 못했습니다.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="cp-modal-backdrop cp-auth-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="cp-recovery-pw-title">
      <div className="cp-modal cp-auth-modal" onClick={(e) => e.stopPropagation()}>
        <h2 id="cp-recovery-pw-title" className="cp-auth-modal-title">
          새 비밀번호 설정
        </h2>
        <p className="cp-auth-modal-hint">재설정 링크로 접속하셨습니다. 새 비밀번호를 입력해 주세요.</p>
        <form onSubmit={handleSubmit} className="cp-auth-modal-form">
          <label className="cp-auth-modal-label" htmlFor="cp-recovery-pw1">
            새 비밀번호
          </label>
          <input
            id="cp-recovery-pw1"
            type="password"
            className="cp-auth-modal-input"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <label className="cp-auth-modal-label" htmlFor="cp-recovery-pw2">
            새 비밀번호 확인
          </label>
          <input
            id="cp-recovery-pw2"
            type="password"
            className="cp-auth-modal-input"
            autoComplete="new-password"
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
          />
          {error && <p className="cp-auth-modal-error">{error}</p>}
          <div className="cp-modal-footer cp-leave-modal-actions">
            <button type="submit" className="cp-btn-primary" disabled={!canSubmit || busy}>
              {busy ? '저장 중…' : '비밀번호 저장'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RecoveryPasswordFormModal;
